const useClickMarkers = () => {
  return (map, handleClickIdeaMarker) => {
    // Add zoom and rotation controls to the map.
    map.on("click", (event) => {
      if (!map?.getLayer("gisData-Point")) {
        return;
      }
      const features = map.queryRenderedFeatures(event.point, {
        layers: [
          "gisData-Point",
          "gisData-LineString-click-clone",
          "gisData-MultiLineString-click-clone",
          "gisData-Polygon-outline-click-clone",
          "gisData-MultiPolygon-outline-click-clone",
        ],
      });

      // [
      //   "gisData-Point",
      //   "gisData-LineString",
      //   "gisData-MultiLineString",
      //   "gisData-Polygon-outline",
      //   "gisData-Polygon-fill",
      //   "gisData-MultiPolygon-outline",
      //   "gisData-MultiPolygon-fill",
      // ],

      const feature = features[0];
      if (feature?.properties?.ideaId) {
        handleClickIdeaMarker(feature.properties?.ideaId);
      }
    });
  };
};

export default useClickMarkers;
